<template>
  <div class="crm-home">
    <div class="toolbar toolbar-between">
      <span class="title">工作台</span>
      <div><crm-notification-settings /> <crm-ai-settings /> <crm-operating-settings /> <el-button size="small" @click="load">刷新</el-button></div>
    </div>
    <el-row :gutter="16" v-loading="loading">
      <el-col :span="4" v-for="card in cards" :key="card.key">
        <div class="stat" @click="$router.push(card.path)">
          <div class="num">{{ stats[card.key] || 0 }}</div>
          <div class="label">{{ card.label }}</div>
        </div>
      </el-col>
    </el-row>
    <div class="metrics" v-loading="loading">
      <div class="stat" v-for="metric in metrics" :key="metric.key" @click="$router.push(metric.path)">
        <div class="num">{{ metric.money ? money(analytics[metric.key]) : (analytics[metric.key] || 0) }}</div>
        <div class="label">{{ metric.label }}</div>
      </div>
    </div>
    <p class="hint">统计日期：{{ analytics.asOfDate || '—' }}（北京时间）。仅统计当前账号可访问的数据；待回款包含逾期，今日到期尚不算逾期。</p>
    <el-row :gutter="16">
      <el-col :xs="24" :md="12">
        <h3>商机漏斗</h3>
        <el-table :data="analytics.funnel || []" border>
          <el-table-column label="阶段"><template slot-scope="{ row }"><el-button type="text" @click="$router.push({path:'/crm/deal',query:{stage:row.stage}})">{{ stages[row.stage] }}</el-button></template></el-table-column>
          <el-table-column prop="count" label="数量" />
          <el-table-column label="金额（元）"><template slot-scope="{ row }">{{ money(row.amount) }}</template></el-table-column>
        </el-table>
      </el-col>
      <el-col :xs="24" :md="12">
        <h3>回款看板</h3>
        <el-table :data="analytics.payments || []" border>
          <el-table-column label="分类"><template slot-scope="{ row }"><el-button type="text" @click="$router.push({path:'/crm/payment',query:{paymentBucket:row.status}})">{{ paymentLabels[row.status] }}</el-button></template></el-table-column>
          <el-table-column prop="count" label="期数" />
          <el-table-column label="金额（元）"><template slot-scope="{ row }">{{ money(row.amount) }}</template></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <p class="hint">线索确认意向后转为客户和商机。公海是无人负责的线索或客户，领取后才进入个人名下。</p>
  </div>
</template>

<script>
import { crm } from '../api/crm'
import CrmOperatingSettings from '../components/CrmOperatingSettings.vue'
import CrmAiSettings from '../components/CrmAiSettings.vue'
import CrmNotificationSettings from '../components/CrmNotificationSettings.vue'

export default {
  name: 'Home',
  components: { CrmOperatingSettings, CrmAiSettings, CrmNotificationSettings },
  data() {
    return {
      loading: false,
      stats: {},
      analytics: {},
      stages: { CONTACT: '接触', DISCOVERY: '需求', PROPOSAL: '方案', WON: '赢单', LOST: '丢单' },
      paymentLabels: { PENDING: '待回款（未逾期）', PAID: '已回款', OVERDUE: '逾期回款' },
      metrics: [
        {key:'newLeadCount',label:'本月新增线索',path:'/crm/lead'},
        {key:'openDealAmount',label:'进行中商机金额（元）',money:true,path:'/crm/deal'},
        {key:'unpaidAmount',label:'待回款含逾期（元）',money:true,path:'/crm/payment'},
        {key:'overdueAmount',label:'逾期回款（元）',money:true,path:'/crm/payment?paymentBucket=OVERDUE'}
      ],
      cards: [
        { key: 'leadCount', label: '线索', path: '/crm/lead' },
        { key: 'poolLeadCount', label: '公海线索', path: '/crm/pool' },
        { key: 'customerCount', label: '客户', path: '/crm/customer' },
        { key: 'openDealCount', label: '进行中商机', path: '/crm/deal' },
        { key: 'openTaskCount', label: '待办提醒', path: '/crm/task' },
        { key: 'pendingApprovalCount', label: '待审批', path: '/crm/approval' }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    money(value) { return Number(value || 0).toLocaleString('zh-CN', {minimumFractionDigits:2,maximumFractionDigits:2}) },
    async load() {
      this.loading = true
      try {
        const [res, analytics] = await Promise.all([crm.workbench(), crm.analytics()])
        this.stats = res.data || {}
        this.analytics = analytics.data || {}
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.crm-home { padding: 4px 0 16px; }
.metrics { display:grid; grid-template-columns:repeat(auto-fit,minmax(200px,1fr)); gap:16px; }
.stat {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  margin-bottom: 16px;
}
.stat:hover { border-color: #0f766e; }
.num { font-size: 28px; font-weight: 700; line-height: 1.2; color: #0f766e; }
.label { font-size: 13px; color: #64748b; margin-top: 6px; }
.crm-home h3, .crm-home .title { font-size: 15px; font-weight: 600; }
.hint { font-size: 12px; color: #64748b; margin-top: 8px; }
</style>
